<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<template>
  <a-result
    status="warning"
    title="You’re offline"
    sub-title="Some features may not be available until your connection is restored."
  >
    <template #extra>
      <a-space>
        <a-button type="primary" @click="router.go(0)">Retry</a-button>
        <a-button @click="router.push('/')">Go Home</a-button>
      </a-space>
    </template>
  </a-result>
</template>
